import { render, staticRenderFns } from "./icon-truck.vue?vue&type=template&id=13d8753c&scoped=true&"
import script from "./icon-truck.vue?vue&type=script&lang=js&"
export * from "./icon-truck.vue?vue&type=script&lang=js&"
import style0 from "./icon-truck.vue?vue&type=style&index=0&id=13d8753c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8753c",
  null
  
)

export default component.exports